<template>
    <span class="location-info">
        <md-icon class="location-info-item" v-if="data == null">
            {{ icon }}
        </md-icon>
        <md-icon
            :class="`${$_getLastLocationUpdateIndicatorColor(convertedDate)}-indicator ${customClass}`"
            v-else
            class="location-info-item vehicle"
        >
            {{ data.source != null ? (data.source === 'Tracker' ? 'drive_eta' : 'phone_iphone') : icon }}
        </md-icon>
        <md-icon class="footer-icon user-pin location-info-item">push_pin</md-icon>
        <p v-if="data == null" class="location-info-item">No location update ever received</p>
        <p
            :class="`${$_getLastLocationUpdateIndicatorColor(convertedDate)}-indicator ${customClass}`"
            v-else-if="data.lastLocationUpdate"
            class="location-info-item"
        >
            {{ convertedDate | dateFormat(dateTypes.standardDateTime) }}
        </p>
    </span>
</template>
<script>
import { GeneralMixin } from '@/mixins';
import { DATE_TYPES } from '@/utils/constants';
import { convertUtcTimeStringToLocalDate } from '@/helpers';

export default {
    name: 'TrackingDriverLocationDataIndicator',
    mixins: [GeneralMixin],
    props: {
        data: {
            type: Object,
            default: () => null
        },
        dateTime: {
            type: String,
            default: null
        },
        direction: {
            type: String,
            default: 'top'
        },
        customClass: {
            type: String,
            default: ''
        },
        renderKey: {
            type: Number,
            default: 0
        },
        icon: {
            type: String,
            default: 'phone_iphone'
        }
    },
    data() {
        return {
            dateTypes: DATE_TYPES
        };
    },
    computed: {
        convertedDate() {
            if (!this.data) {
                return null;
            }

            const { lastLocationUpdate, utcOffset } = this.data;
            return convertUtcTimeStringToLocalDate(lastLocationUpdate, utcOffset);
        }
    },
    watch: {
        renderKey() {
            this.$forceUpdate();
        }
    }
};
</script>
<style lang="scss" scoped>
.location-info {
    display: flex;
    gap: 3px;
    width: 50%;

    p {
        font-size: smaller;
        line-height: 16px;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 5px;
    }

    .md-icon {
        margin: 0;
        &.user-pin {
            transform: rotate(90deg);
            font-size: 15px !important;
        }

        &.vehicle {
            font-size: 23px;
        }
    }
}
</style>
